import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { AxiosResponse, CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';

const columns = [
  { field: 'stars', headerName: 'Stars', width: 110 },
  { field: 'levelRocklets', headerName: 'Level Rocklets', width: 169 },
  { field: 'consumableRocklets', headerName: 'Consumable Rocklets', width: 216 },
  { field: 'rockletsDiff', headerName: 'Rocklets Diff', width: 159 },
  { field: 'productId', headerName: 'Product Id', width: 143 },
  { field: 'upgrade', headerName: 'Upgrade', width: 130 },
  { field: 'timestamp', headerName: 'Timestamp', width: 170 },
  { field: 'packagee', headerName: 'Package', width: 160 },
  { field: 'trade', headerName: 'Traded', width: 350 },
];

interface VipInfo {
  stars: number;
  levelRocklets: number;
  consumableRocklets: number;
  rockletsDiff: number;
  productId: string;
  upgrade: number;
  timestamp: string;
  packagee: string;
  category: string;
  cash: number;
  coins: number;
  extras: number;
  gameId: string;
}

function creatVipTrade(info: VipInfo): string {
  let trade = '';

  switch (info.category) {
    case 'CASH':
      trade = `${info.cash} ${info.category}`;
      break;
    case 'COINS':
      trade = `${info.coins} ${info.category}`;
      break;
    case 'CARDS':
    case 'SPINS':
    case 'EXTRAS': {
      trade = `${info.extras} ${info.category} ${info.gameId}`;
      break;
    }
    default:
      trade = `Invalid category`;
  }
  return trade;
}

let index = 0;
function createData(info: VipInfo) {
  index += 1;
  return { id: index, trade: creatVipTrade(info), ...info };
}

const PlayerVip = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<VipInfo[]>(`/admin/diffs/vip/player/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<VipInfo[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });
  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PlayerVip;
